<div class="menu-trigger" id="hamburgerBtn" (click)="hamburgerOpen()">
  <span>
    <i class="fa fa-bars" aria-hidden="true" [style.color]="brandingDetails?.branding?.BackgroundColors?.HeaderFontColor"></i>
  </span>
</div>
<div id="overlay" class="hideOverlay" (click)="closeSidebar($event)"></div>
<div class="sidenavmain hideDiv styleside" id="sidebar" *ngIf="tenant">
  <div [style.background-color]="sideBarBackgroundColor" class="sidenav">
    <div class="menu-close" (click)="closeSidebar($event)" [style.color]="brandingDetails?.branding?.BackgroundColors?.CloseIcon">
      <i class="fa fa-times"></i>
    </div>
    <div class="logo d-flex justify-content-center">
      <a [routerLink]="['/dashboard']"> <img class="logoIcon" alt="Agency Logo" src="{{brandingDetails?.branding?.MainLogo}}" /> </a>
    </div>
    <div class="versiontextstyle">
      <ul class="navbar-nav style-ul">
        <ng-container *ngFor="let sidebarMenu of sidebarContent">
          <li class="nav-item" *ngIf="menuPermissions[sidebarMenu?.permissionKey]"
          [style.background-color]="sidebarNav?.classList?.contains('active') ? sideBarActiveBackgroundColor : hoveredMenu === sidebarMenu?.hoverKey ? sideBarHoverBackgroundColor : ''"
          (mouseover)="onMouseOver(sidebarMenu?.hoverKey)" (mouseleave)="onMouseLeave()">

            <a  class="nav-link" [routerLink]="[sidebarMenu?.route]" [routerLinkActive]="['active']" #sidebarNav
              (click)="closeSidebar($event); sidebarMenu?.onClick ? this[sidebarMenu?.onClick]() : null;" [style.color]="sideBarFontColor"
              [routerLinkActiveOptions]="sidebarMenu?.routerLinkActiveOptions">
              <div class="{{sidebarMenu?.iconClass}} ht-33" src="" [routerLinkActive]="[sidebarMenu?.routerLinkActive]"></div>
              <span [style.color]="sidebarNav?.classList?.contains('active') ? sideBarActiveFontColor : sideBarFontColor">{{sidebarMenu?.label | translate}}</span>
            </a>

          </li>
        </ng-container>
        <li class="nav-item" *ngIf='menuPermissions?.switchAgency' (click)="openSuperAdminModal()"
        [style.background-color]="sidebarNav?.classList?.contains('active') ? sideBarActiveBackgroundColor : hoveredMenu === 'switchAgency' ? sideBarHoverBackgroundColor : ''"
        (mouseover)="onMouseOver('switchAgency')" (mouseleave)="onMouseLeave()">
          <a class="nav-link"  [routerLinkActive]="['active']" style="cursor: pointer;" #sidebarNav [style.color]="sideBarFontColor">
            <div class="agencyIcon ht-33" src="" [routerLinkActive]="['agencyActive']" style="padding-top: 3px;padding-left: 3px;height: 28px !important;"></div>
            <span style="padding-left: 3px;" [style.color]="sidebarNav?.classList?.contains('active') ? sideBarActiveFontColor : sideBarFontColor">{{'Switch Agency' | translate}}</span>
          </a>
        </li> 
      </ul>
      <li class="nav-item versionText">
        <div class="bottom-text" *ngIf="version">
          v {{version}}
        </div>
      </li>
    </div>
  </div>
</div>

